/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const componentDictionary = {};

componentDictionary['__local__|__local__|themes|fabrikam|views|components|addtocart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-addtocart' */
                'partner/themes/fabrikam/views/components/addtocart.component.tsx'),
            cn: '__local__-__local__-addtocart'
        };
componentDictionary['__local__|__local__|themes|fabrikam|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cartlineitem' */
                'partner/themes/fabrikam/views/components/cartlineitem.component.tsx'),
            cn: '__local__-__local__-cartlineitem'
        };
componentDictionary['__local__|__local__|themes|fabrikam|views|components|price'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-price' */
                'partner/themes/fabrikam/views/components/price.component.tsx'),
            cn: '__local__-__local__-price'
        };
componentDictionary['__local__|__local__|themes|fabrikam|views|components|product'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product' */
                'partner/themes/fabrikam/views/components/product.component.tsx'),
            cn: '__local__-__local__-product'
        };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/cartlineitem.component.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem'
        };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/promocode.component.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode'
        };